// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/sass/style.scss
// module id = ./resources/assets/site/sass/style.scss
// module chunks = 0